import useSWR from "swr";
import { Paths } from "../Services/EndPoints";
import { fetcher } from "../Utils/HelperFunctions";

/**
 * Is the store owner reachable on WhatsApp right now?
 *
 * One definition for every chat surface — the storefront FAB, the PDP button, the About page CTA,
 * search zero-results, the 404 and the drawer. Each of them reading `about_me` and deciding for
 * itself is how two buttons on the same screen end up disagreeing.
 *
 * The answer comes from the BACKEND, in IST. The browser's clock belongs to the buyer, who may be
 * anywhere: a shopper in London would otherwise see a Hyderabad seller as shut all afternoon.
 *
 * `undefined` — an older backend, or the request still in flight — counts as available, so no
 * button goes dark merely because the answer has not arrived yet. It is the same shared SWR cache
 * key the surfaces already use, so this adds no extra request.
 *
 * @returns {{ offline: boolean, ownerFirstName: string|undefined, store: object|undefined }}
 */
export default function useContactAvailable() {
  const { data: store } = useSWR(Paths.about_me, fetcher);

  return {
    offline: store?.contactAvailable === false,
    ownerFirstName: store?.firstName,
    store,
  };
}
